/**
 * Minimaler Toast-Helper als Ersatz für `window.alert()`. Stack rechts oben,
 * 5s Auto-Dismiss (länger bei Errors), schließbar per ✕. Mehrere Toasts stacken
 * untereinander. Vario-Slot rendert die Frontend-App in einem iframe — `alert()`
 * würde das gesamte Vario-UI blockieren und sieht unprofessionell aus.
 *
 * Drei Level: `info` (default, neutral), `success` (grün), `error` (rot,
 * längere Dauer da der User oft Details brauchen wird).
 */
const STACK_ID = 'kl-toast-stack';
const DEFAULT_DURATION_MS = {
    info: 5_000,
    success: 5_000,
    error: 10_000,
};
function ensureStack() {
    let stack = document.getElementById(STACK_ID);
    if (!stack) {
        stack = document.createElement('div');
        stack.id = STACK_ID;
        stack.className = 'kl-toast-stack';
        document.body.appendChild(stack);
    }
    return stack;
}
function escapeHtml(s) {
    return s.replace(/[&<>"']/g, (c) => c === '&' ? '&amp;' : c === '<' ? '&lt;' : c === '>' ? '&gt;' : c === '"' ? '&quot;' : '&#39;');
}
export function showToast(message, level = 'info') {
    const stack = ensureStack();
    const toast = document.createElement('div');
    toast.className = `kl-toast kl-toast--${level}`;
    toast.innerHTML = `
    <span class="kl-toast-msg">${escapeHtml(message)}</span>
    <button type="button" class="kl-toast-close" aria-label="Schließen">&times;</button>
  `;
    stack.appendChild(toast);
    const dismiss = () => {
        toast.classList.add('kl-toast--leaving');
        setTimeout(() => toast.remove(), 200);
    };
    toast.querySelector('.kl-toast-close')?.addEventListener('click', dismiss);
    setTimeout(dismiss, DEFAULT_DURATION_MS[level]);
}
//# sourceMappingURL=toast.js.map